/* eslint-disable*/

import React from "react";
import {
  createBrowserRouter,
  Route,
  createRoutesFromElements,
  Outlet,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import NotFound from "../components/404NotFound/index";
import Header from "../components/Header";
import Home from "../components/Home";
import FooterContainer from "../containers/Footer";
import ComingSoon from "../components/Home/Coming";
import BookingModal from "../components/Home/BookingModal";
import { useBooking } from "../BookingContext";
import AppRedirect from "../components/Home/AppRedirect";

const BasicLayout = () => {
  const location = useLocation();
  const { isOpen, open, close } = useBooking();
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Header onBook={open} />
      <div style={{ flexGrow: 1 }}>
        <Outlet />
      </div>
      {!["/coming_soon", "*"].includes(location.pathname) && <FooterContainer />}
      <BookingModal isOpen={isOpen} onClose={close} />
    </div>
  );
};

const NotFoundLayout = () => {
  const { open } = useBooking();
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Header onBook={open} />
      <div style={{ flexGrow: 1 }}>
        <Outlet />
      </div>
    </div>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route key="/" path="/" element={<BasicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/coming_soon" element={<ComingSoon />} />
        <Route path="/app" element={<AppRedirect   />} />
      </Route>
      <Route element={<NotFoundLayout />}>
        <Route path="*" element={<NotFound />} />
      </Route>
    </>
  )
);

export default (
  <div className="container-fluid p-0">
    <RouterProvider router={router} />
  </div>
);
